import { focusOn as f } from "./commands.js";
import { contains as b, getTabbableNodes as c, getFocusableNodes as v } from "./utils/DOMutils.js";
import { asArray as i } from "./utils/array.js";
var m = function(r, e, t) {
  if (!r || !e)
    return console.error("no element or scope given"), {};
  var n = i(e);
  if (n.every(function(u) {
    return !b(u, r);
  }))
    return console.error("Active element is not contained in the scope"), {};
  var a = t ? c(n, /* @__PURE__ */ new Map()) : v(n, /* @__PURE__ */ new Map()), o = a.findIndex(function(u) {
    var d = u.node;
    return d === r;
  });
  if (o !== -1)
    return {
      prev: a[o - 1],
      next: a[o + 1],
      first: a[0],
      last: a[a.length - 1]
    };
}, y = function(r, e) {
  var t = e ? c(i(r), /* @__PURE__ */ new Map()) : v(i(r), /* @__PURE__ */ new Map());
  return {
    first: t[0],
    last: t[t.length - 1]
  };
}, g = function(r) {
  return Object.assign({
    scope: document.body,
    cycle: !0,
    onlyTabbable: !0
  }, r);
}, s = function(r, e, t) {
  e === void 0 && (e = {});
  var n = g(e), a = m(r, n.scope, n.onlyTabbable);
  if (a) {
    var o = t(a, n.cycle);
    o && f(o.node, n.focusOptions);
  }
}, w = function(r, e) {
  e === void 0 && (e = {}), s(r, e, function(t, n) {
    var a = t.next, o = t.first;
    return a || n && o;
  });
}, E = function(r, e) {
  e === void 0 && (e = {}), s(r, e, function(t, n) {
    var a = t.prev, o = t.last;
    return a || n && o;
  });
}, l = function(r, e, t) {
  var n, a = y(r, (n = e.onlyTabbable) !== null && n !== void 0 ? n : !0), o = a[t];
  o && f(o.node, e.focusOptions);
}, F = function(r, e) {
  e === void 0 && (e = {}), l(r, e, "first");
}, M = function(r, e) {
  e === void 0 && (e = {}), l(r, e, "last");
};
export {
  F as focusFirstElement,
  M as focusLastElement,
  w as focusNextElement,
  E as focusPrevElement,
  m as getRelativeFocusable
};
